<template>

    <span class="bmd-form-group">

        <div class="input-group" v-if="icon">
            <div class="input-group-prepend">
                <span class="input-group-text">
                    <i class="material-icons">{{ icon }}</i>
                    <span class="trax-required" v-if="required">*</span>
                </span>
            </div>
            <span class="form-control trax-form-control-select">

                <select :id="id" class="selectpicker" data-live-search="true" data-style="select-with-transition" :disabled="disabled">
                    <option value="" v-if="value && unselect">Unselect</option>
                    <option value="" disabled selected v-if="showUnselected"> {{ unselectedLabel }}</option>
                    <option value="" disabled selected v-else-if="showNoOption"> {{ noOptionLabel }}</option>
                    <option value="" disabled selected v-else-if="loading">Loading...</option>
                    <option v-for="option in options" :key="option.value" :value="option.value">
                        {{ option.name }}
                    </option>
                </select>
                
            </span>
        </div>
        
        <div class="row" v-else-if="col">
            <label :class="labelClass" style="padding-top:1.7rem;">
                {{ placeholder }}
                <span class="trax-required" v-if="required">*</span>
            </label>
            <div :class="formColClass">
                <span class="form-control trax-form-control-select">

                    <select :id="id" class="selectpicker" data-live-search="true" data-style="select-with-transition" :disabled="disabled">
                        <option value="" v-if="value && unselect">Unselect</option>
                        <option value="" disabled selected v-if="showUnselected"> {{ unselectedLabel }}</option>
                        <option value="" disabled selected v-else-if="showNoOption"> {{ noOptionLabel }}</option>
                        <option value="" disabled selected v-else-if="loading">Loading...</option>
                        <option v-for="option in options" :key="option.value" :value="option.value" >
                            {{ option.name }}
                        </option>
                    </select>
            
                </span>
                <span class="trax-form-error" v-if="error"> {{ error }} </span>
            </div>
        </div>
        <div v-else>
            <span class="form-control trax-form-control-select">

                <select :id="id" class="selectpicker" data-live-search="true" data-style="select-with-transition" :disabled="disabled">
                    <option value="" v-if="value && unselect">Unselect</option>
                    <option value="" disabled selected v-if="showUnselected"> {{ unselectedLabel }}</option>
                    <option value="" disabled selected v-else-if="showNoOption"> {{ noOptionLabel }}</option>
                    <option value="" disabled selected v-else-if="loading">Loading...</option>
                    <option v-for="option in options" :key="option.value" :value="option.value" >
                        {{ option.name }}
                    </option>
                </select>
                
            </span>
            <span class="trax-form-error" v-if="error"> {{ error }} </span>
        </div>
        <span class="trax-form-error" v-if="error && icon"> {{ error }} </span>
    </span>
    
</template>

<script>
    export default {

        props: {
            error: null,
            icon: null,
            col: null,
            endpoint: null,
            value: null,
            disabled: null,
            insideLabel: null,
            placeholder: null,
            unselectedLabel: null,
            noOptionLabel: null,
            required: null,
            unselect: null,
            noneSelectedText: {default: lang.polaris.form.nothing_selected},
            exclude: [],
            filters: {default: () => ({})},
        },

        data() {
            return {
                id: 'trax-ui-select-'+this.uuid(), 
                colBreak: null,
                colSize: null,
                options: [],  // {name, value}
                loading: false,
                loaded: false,
                searchTimer: null,
            }
        },

        computed: {

            showUnselected() {
                return !this.loading && !this.showNoOption
            },

            showNoOption() {
                return this.loaded && this.options.length == 0
            },

            labelClass: function() {
                if (!this.col) return '';
                return 'col-form-label col-'+this.col+' text-left text-'+this.colBreak+'-right pl-3';
            },

            formColClass: function() {
                if (!this.col) return '';
                return 'col-'+this.colBreak+'-'+(12-this.colSize);
            }
        },

        created: function() {
            if (!this.col) return;
            var parts = this.col.split('-');
            this.colBreak = parts[0];
            this.colSize = parts[1];
        },

        mounted() {
            var that = this;
            
            $('.selectpicker#'+this.id).on('changed.bs.select', function (e, clickedIndex, newValue, oldValue) {
                that.$emit('input', this.value ? this.value : null );
                that.$emit('changed', that.getObject(this.value));
            });

            $('.selectpicker#'+this.id).on('show.bs.select', function (e, clickedIndex, newValue, oldValue) {
                // Scope the searchbox to this select: there may be several remote search selects on the page.
                const $searchbox = $(this).closest('.bootstrap-select').find('.bs-searchbox input');

                $searchbox.off('input.remote-search'); // prevent duplicate bindings
                $searchbox.on('input.remote-search', function () {
                    const search = $(this).val();

                    clearTimeout(that.searchTimer);

                    that.searchTimer = setTimeout(() => {
                        that.loadOptions(search)
                    }, 500);
                });
            });

            // Force initial value.
            $('.selectpicker#'+this.id).selectpicker('refresh');
            $('.selectpicker#'+this.id).selectpicker('val', this.value);
        },

        updated() {
            $('.selectpicker#'+this.id).selectpicker('refresh');
            $('.selectpicker#'+this.id).selectpicker('val', this.value);
        },

        watch: {
            value(value) {
                if (value) {
                    $('.selectpicker#'+this.id).selectpicker('val', value);
                } else {
                    $('.selectpicker#'+this.id).selectpicker('val', "");
                }
            },
        },

        methods: {

            loadOptions(search) {
                this.loading = true
                $('.selectpicker#'+this.id).selectpicker('refresh');
            
                var filters = Object.assign({}, this.filters, {nameSearch: search});

                axios.get(this.endpoint, { params: { filters: filters }}).then(response => {

                    this.options = response.data.filter(option => {
                        return this.exclude ? !this.exclude.includes(option.value) : true
                    })

                    this.loading = false
                    this.loaded = true

                    // Check that the current value is still in the options.
                    if (this.value && !this.options.find(option => option.value == this.value)) {
                        this.$emit('input', null);
                        this.$emit('changed', null);
                    } else {
                        this.$emit('initialized', this.getObject(this.value));
                    }

                    // Force options and value.
                    $('.selectpicker#'+this.id).selectpicker('refresh');
                    $('.selectpicker#'+this.id).selectpicker('val', this.value);
                })
                .catch(error => {
                });
            },
            
            getObject(value) {
                if (!value) {
                    return null
                }
                return this.options.find(item => value == item.value).object
            },
            
            uuid() {
                var res = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8);
                    return v.toString(16);
                });
                return res;
            }
        }
    }
</script>

<style scoped>

    .trax-form-control-select >>> li.disabled span.material-icons {
        display: none !important;
    }

    .trax-form-control-select >>> .dropdown-menu.show {
        max-width: 350px !important;
    }

</style>